import React from 'react';
import PropTypes from 'prop-types';
import styles from '../app/App.scss';

const FullscreenIframe = (props) => {
    const {
        srcURL,
        displayStyle,
        displayHeight,
    } = props;

    return (
        <iframe
            src={srcURL}
            id="fullscreen-iframe"
            className={styles.fullscreenIframe}
            title="fullscreenIframe"
            style={{ height: displayHeight, display: displayStyle }}
        />
    );
};

FullscreenIframe.propTypes = {
    srcURL: PropTypes.string,
    displayStyle: PropTypes.string,
    displayHeight: PropTypes.string,
};

export default FullscreenIframe;
